import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/health-docs.jpeg";

function HelseInformasjon() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.healthInformation.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.healthInformation.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/helseinformasjon-alle-kan-forsta"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.healthInformation.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.healthInformation.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.healthInformation.date")}
          </p>
        </div>
        <img
          src={article_img}
          className="w-full md:w-2/5"
          alt={i18next.t("pages.articles.list.healthInformation.imageAlt")}
        />
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <p>{i18next.t("pages.articles.list.healthInformation.sections.intro.content")}
            <a href="/artikler/tilgjengelighetsdirektivet" className=" underline hover:text-contrast-ink">
              {i18next.t("pages.articles.list.healthInformation.sections.intro.link")}
            </a>
            {i18next.t("pages.articles.list.healthInformation.sections.intro.content2")}
            </p>
           
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.healthInformation.sections.journey.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.healthInformation.sections.journey.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.healthInformation.sections.risk.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.healthInformation.sections.risk.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.healthInformation.sections.solution.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.healthInformation.sections.solution.content")}</p>
            <p className="mt-4 mb-2">{i18next.t("pages.articles.list.healthInformation.sections.solution.subtitle")}</p>
            <ul className="list-disc list-outside ml-6 mt-2 mb-4">
              <li>{i18next.t("pages.articles.list.healthInformation.sections.solution.features.1")}</li>
              <li>{i18next.t("pages.articles.list.healthInformation.sections.solution.features.2")}</li>
              <li>{i18next.t("pages.articles.list.healthInformation.sections.solution.features.3")}</li>
            </ul>
            <a href="/artikler/gjor-dokumentene-dine-tilgjengelige" className=" underline hover:text-contrast-ink ">{i18next.t("pages.articles.list.healthInformation.sections.solution.readMore")}</a>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.healthInformation.sections.benefit.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.healthInformation.sections.benefit.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.healthInformation.sections.advice.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.healthInformation.sections.advice.content")}</p>
            <p className="mt-6">
              <a href="/skjema/kontakt-oss" className="font-bold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.healthInformation.sections.advice.cta")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelseInformasjon;


